import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavController, ModalController} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import {SearchPage} from "../search/search";
import {CartPage} from "../cart/cart";
import {NavParams } from 'ionic-angular';
import { Http, Headers } from '@angular/http';
import { IMAGES_BASE_URL } from "../../providers/config";
import {CartManager} from "../../providers/cart-manager";
import {Constants,ApplicationVariables} from "../../providers/config";
import {BarcodeModalPage} from "../barcode-modal/barcode-modal";
import  {LoginPage} from '../login/login';

import { MsgManager } from '../../providers/msg-manager';
import {Api} from "../../providers/api";

import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

import { Slides } from 'ionic-angular';
import * as moment from 'moment';

import { Base64 } from 'js-base64';
import {GVLogger} from "../../services/gv-logger";
/*
 Generated class for the LoginPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-item',
  templateUrl: 'item-details.html'
})
export class ItemPage {

   @ViewChild(Slides) slides: Slides;
  @ViewChild('divID') divID: ElementRef;

  showNegative = false;
  // item info
  constants = Constants;
  public item: any;
  public item_id: any;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  isOfflineMode:any = false;


  attributes = [];

  cacheImages= true;

  adpCustomerInfo:any ={};

  trustedVideoUrl:SafeResourceUrl;
  pageStatus: any;
  cartDisplay: boolean = false;

  constructor(public nav: NavController, public modalCtrl: ModalController,
    public params:NavParams, public http: Http,private cartManager:CartManager,
    private storage:Storage,
    private msgManager:MsgManager,
    private api:Api,
    private domSanitizer:DomSanitizer, private gVLogger: GVLogger) {

      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.trustedVideoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/MLleDRkSuvk");

    this.isOfflineMode = ApplicationVariables.isOffline;

    this.storage.get("cacheImages").then((cache)=>{
     this.cacheImages = cache;
   });


    this.storage.get("negativeInventory").then((negativeInventory)=>{
     this.showNegative = negativeInventory;
   });
    // get the first item as sample data
    this.item = params.get("item");//itemService.getItem(1);
    this.pageStatus = params.get("status");
    if(this.pageStatus != undefined && this.pageStatus != null && this.pageStatus === "fromReceiveStock"){
      this.cartDisplay = true;
    }

    if(this.item.attributeSearch !== ""){
      this.attributes = this.item.attributesList;

      // for (let att of this.item.attributeSearch.split(">")){
      //   this.gVLogger.log(att);
      //   this.attributes.push({key: att.split(":")[0],value: att.split(":")[1]});
      // }
    }
  }


  decodedDescription(description){
    // this.gVLogger.log( "decjsdkld ghjd gnkxdhn   : " + atob(description));

    try {
      this.gVLogger.log("In try decoded description : " + Base64.decode(description));
      this.gVLogger.log("In try encoded description : " + description);
      this.divID.nativeElement.innerHTML = Base64.decode(description);
    }
    catch (e) {
      this.gVLogger.log("In catch decoded description : ")
      this.divID.nativeElement.innerHTML = description;
    }

    // this.divID.nativeElement.1innerHTML = decodeURIComponent(escape(window.atob(description)));
    // atob(description);
    // return atob(description); // for decoding the description
  }

  loadHtml(){
    // this.divID.nativeElement.innerHTML = this.html;
  }

    // go to search page
  goToSearch() {
    this.nav.push(SearchPage);
  }

  // view cart
  goToCart() {
    this.nav.push(CartPage);
  }

  addProductToCart(item){
    this.cartManager.addProductToCart(item);
  }

  removeProductFromCart(product){
    this.cartManager.removeOneNew(product);
  }

  updateProductInCart(product){
  if(String(product.quantity) !=""){
    if(String(product.quantity).match(/^\d+$/)){

      this.cartManager.updateCartNew(product);

    }else{
      product.quantity = Number(product.minOrder);
      this.cartManager.updateCartNew(product);
    }
  }else{
      product.quantity = Number(product.minOrder);
      this.cartManager.updateCartNew(product);
  }


  }



  imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }


discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

 decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  testPopup(){
    let producModal = this.modalCtrl.create(BarcodeModalPage,{product:this.item});
    producModal.present();
  }

 discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }


  bookmarkProduct(item){

  this.api.get("customers/likeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 1;
        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });
}

unBookmarkProduct(item){

  this.api.get("customers/dislikeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 0;
        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });

}

makeImageURL(dimensions,imagesDto){
  return this.cartManager.makeImageURLByImagesDtoObject(dimensions,imagesDto);
}

getDateString(date){
  return new Date(date).toDateString();
}

checkValidDate(date){

  if(moment(date, "DD-MM-YYYY").isValid()){
    return true;
  }
  else{
    return false;
  }
}

slideForward(){
  this.slides.slideNext();
}

slideBack(){
this.slides.slidePrev();
}

}



// WEBPACK FOOTER //
// ./src/pages/item-details/item-details.ts